import { X } from 'lucide-react'

interface SummaryStripProps {
  count: number
  /** Pre-formatted amount string (caller uses useCurrency().format). */
  amount: string
  /** When true, a "Clear filters" button is shown at the right. */
  filtersActive?: boolean
  onClearFilters?: () => void
}

// Top-of-tab summary: same numbers as the footer (count includes voided; amount
// excludes voided — mismatch inherited from the footer, acceptable for now).
// Also hosts the Clear-all-filters button (Feature 5), shown only when a header
// filter is active. Date pill / search / Show-voided are NOT cleared by it.
export function SummaryStrip({ count, amount, filtersActive, onClearFilters }: SummaryStripProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-gray-100 bg-gray-50/60 px-4 py-2.5">
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-sm">
        <span className="text-gray-500">
          Total Payments: <strong className="text-gray-900">{count}</strong>
        </span>
        <span className="hidden text-gray-300 sm:inline">|</span>
        <span className="text-gray-500">
          Total Amount: <strong className="text-gray-900">{amount}</strong>
        </span>
      </div>
      {filtersActive && onClearFilters && (
        <button
          type="button"
          onClick={onClearFilters}
          className="inline-flex items-center gap-1 rounded-lg px-2 py-1 text-xs font-medium text-brand-600 hover:bg-brand-50"
        >
          <X className="h-3.5 w-3.5" />
          Clear filters
        </button>
      )}
    </div>
  )
}
